/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import './animation002.less';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation002Item {
  icon?: string;
  text: string | React.ReactNode;
  title: string | React.ReactNode;
  style?: React.CSSProperties;
}

interface IAnimation002Props {
  title: string | React.ReactNode;
  items: IAnimation002Item[];
  onCompleted?: () => void;
  className?: string;
}

const Animation002: React.FunctionComponent<IAnimation002Props> = ({
  title,
  items,
  onCompleted,
  className,
}) => {
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= 5) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };
  return (
    <div
      className={`animation002 component ${className}`}
      onClick={() => startPlay()}
    >
      <img
        className={`click-point ${play > 1 ? 'hide' : ''}`}
        src={ImgPoint}
        alt=""
      />
      {typeof title === 'string' ? (
        <div
          className="bp-center-circle"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      ) : (
        <div className="bp-center-circle">{title}</div>
      )}
      {items.map((itm, idx) => (
        <div
          key={idx}
          className={`bp-panel animation ${
            play > idx ? 'fade-in' : ''
          } bp-panel-${idx + 1}`}
          style={itm.style}
        >
          {typeof itm.title === 'string' ? (
            <div
              className="bp-panel-title"
              dangerouslySetInnerHTML={{ __html: itm.title }}
            />
          ) : (
            <div className="text">{itm.text}</div>
          )}
          {typeof itm.text === 'string' ? (
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          ) : (
            <div className="text">{itm.text}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Animation002;
